{
  "yourAssets": "Your assets",
  "yourAssetsOn": "Your assets on",
  "setDate": "Set date for this view",
  "edit": "Edit",
  "share": "Share",
  "done": "Finish edit",
  "pleaseWait": "Please wait while we load your data...",
  "externalSync": "Your banks are still sending data (up to 60s)...",
  "postFile": {
    "header": "Which account?",
    "prompt": "Please select the account to which you want to import the file."
  },
  "shareReport": {
    "header": "Share Dashboard",
    "tooltip": "We will create a link for you to share your dashboard with others. Please set a simple passcode to protect your data.",
    "next": "Next",
    "confirmation": {
      "copy": "Copy",
      "copyBoth": "Send the link and the passcode to the recipient. They will get access to your dashboard with today's data.",
      "securityHint": "If possible, do not send the passcode and the link in the same message or in the same chat."
    }
  },
  "sharedReportViewer": {
    "header": "Passcode",
    "prompt": "Please enter your passcode to access the Dashboard.",
    "reportNotFound": "Dashboard not found",
    "unableToLoadReport": "We were unable to load the report. Please check the passcode and try again."
  },
  "categories": {
    "deposits": "Bank accounts",
    "stocks": "Stockbroker accounts",
    "pension": "Pension plans",
    "realEstate": "Real estate",
    "objectsOfValue": "Objects of value",
    "metals": "Precious metals",
    "loans": "Loans",
    "unlistedShares": "Unlisted shares",
    "crypto": "Cryptocurrencies"
  },
  "singleCategory": {
    "deposits": "Bank account",
    "stocks": "Stock brokerage account",
    "pension": "Pension plan",
    "realEstate": "Real estate",
    "objectsOfValue": "Object of value",
    "metals": "Precious metal",
    "loans": "Loan",
    "unlistedShares": "Unlisted shares",
    "crypto": "Cryptocurrency"
  },
  "sumtile": {
    "change": "Change vs. the same indicator in previous period.",
    "inconsistent": "Inconsistent transactions",
    "warning": "There are inconsistencies in your data which may affect this number. Click here to see details.",
    "orphanedDialog": {
      "assetTransactionsDialogTitle": "Asset transactions with no deposit transactions",
      "netWorthExplanation": "In order to calculate your net worth and its changes correctly, each sale of asset needs to be linked to a transaction on a bank / cash account. You can do that by labelling the correct bank transaction in your bank account.",
      "notLinkedTransactionsExplanation": "The following transactions are not linked to any deposit transaction. Click one to go to the first linked deposit account for that transaction and label the matching transaction there.",
      "transactionTableHeaders": {
        "date": "Date",
        "assetAccount": "Asset account",
        "assetName": "Asset name",
        "amount": "Amount",
        "price": "Value"
      },
      "closeButtonText": "Close"
    },
    "generalIncome": {
      "label": "General income",
      "tooltip": "Income from external sources, such as employment."
    },
    "incomeFromCapital": {
      "label": "Income from capital",
      "tooltip": "Income from capital, such as dividends or gains/losses from sales of investments. Blue circle next to a transaction means that this transaction is included in this category."
    },
    "assetValueIncrease": {
      "label": "Asset value change",
      "tooltip": "Change in the value of assets, such as stocks, bonds, real estate, etc."
    },
    "outflows": {
      "label": "Outflows",
      "tooltip": "General expenses, such as rent, utilities, etc. Purchases of investment assets are not included in this category"
    },
    "previousValue": {
      "label": "Baseline value",
      "tooltip": "Total value of all your assets at the beginning of the baseline period that you selected below.",
      "selectBaseline": "Select a baseline date:",
      "sameTimeLastYear": "One year ago",
      "beginning": "Beginning of this year",
      "beginningLastYear": "Beginning of last year",
      "custom": "Custom"
    },
    "changeInValue": {
      "label": "Change in value",
      "tooltip": "Difference between the total value of all your assets at the beginning of the period that you selected and today."
    },
    "currentNetWorth": {
      "label": "Current net worth",
      "tooltip": "Value of all your assets minus value of all loans that you took."
    }
  }
}